// components/AuthGuard.js
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import VipTeaser from './VipTeaser';

const useLeagueData = (leagueId) => {
  const [leagueData, setLeagueData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLeagueData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/competitions`);
        const competitions = await response.json();

        let foundLeague = null;
        Object.keys(competitions).forEach(level => {
          const league = competitions[level].find(comp => comp.competition_id === parseInt(leagueId));
          if (league) foundLeague = league;
        });

        if (foundLeague) {
          setLeagueData(foundLeague);
        } else {
          setError('Liga nie została znaleziona.');
        }
      } catch (err) {
        setError('Błąd podczas pobierania danych ligi: ' + err.message);
        console.error('Error fetching league data:', err);
      } finally {
        setLoading(false);
      }
    };

    if (leagueId) fetchLeagueData();
    else setLoading(false);
  }, [leagueId]);

  return { leagueData, loading, error };
};



const AuthGuard = ({ children, requiredRole = 'admin' }) => {
  const { user, loading, hasRole, vipModeEnabled } = useAuth();
  
  console.log('AuthGuard render → vipModeEnabled:', vipModeEnabled);

  // 1. Najpierw zawsze czekamy na zakończenie ładowania
  if (loading) {
    return <div>Sprawdzanie uprawnień...</div>;
  }

  // 2. Po zakończeniu ładowania – sprawdzamy, czy użytkownik istnieje
  if (!user) {
    // użytkownik nie jest zalogowany → zawsze redirect na login
    return <Navigate to="/login" replace />;
  }

// ───────────────────────────────────────────────
  // Logika VIP – włączamy blokadę tylko gdy vipModeEnabled = true
  // ───────────────────────────────────────────────
  const isVipRequired = requiredRole === 'vip';
  const isBlockedForNonVip = isVipRequired && vipModeEnabled && !hasRole('vip');

  if (isBlockedForNonVip) {
    return <VipTeaser />;
  }

  // admin zawsze przechodzi (nawet gdy vipModeEnabled = true)
  if (requiredRole === 'admin' && !hasRole('admin')) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export { AuthGuard, useLeagueData };